import jsCookie from 'js-cookie';

var TOKEN_COOKIE_NAME = 'staff_token';

// 内存缓存：postMessage 写入的可信 token，优先级高于 document.cookie
var _trustedToken = null;

/**
 * 包装 js-cookie：staff_token cookie 由后端独占管理，前端通过内存缓存读取可信 token。
 * 生产环境（HTTPS）不写 cookie，完全依赖后端的 domain cookie；
 * 本地开发（HTTP）写一份 host-only cookie 作为 fallback，因为后端 Secure/SameSite 配置在 HTTP 下可能不生效
 */
var cookie = {
  get: function (name) {
    if (name === TOKEN_COOKIE_NAME && _trustedToken) {
      return _trustedToken;
    }
    return jsCookie.get(name);
  },
  set: function (name, value, options) {
    if (name === TOKEN_COOKIE_NAME) {
      _trustedToken = value;
      // HTTP 本地开发时后端 cookie 可能因 Secure/SameSite 不生效，写一份 fallback
      if (window.location.protocol !== 'https:') {
        jsCookie.set(name, value, { path: '/' });
      }
      return;
    }
    return jsCookie.set(name, value, options);
  },
  remove: function (name, options) {
    if (name === TOKEN_COOKIE_NAME) {
      _trustedToken = null;
      // 清理可能残留的 host-only cookie
      jsCookie.remove(name, { path: '/' });
      return;
    }
    return jsCookie.remove(name, options);
  }
};

export default cookie;
